export default __webpack_public_path__ + "static/media/logo-ce.e4606db5.png";